module.exports = __webpack_public_path__ + "sl-edit-1.5e95bc18b441743fd78d83dca570ddb0.svg";